import { fork, all, put, takeLatest, select } from 'redux-saga/effects'
import {
    CHECK_ACCESS_TOKEN,
    CLEAR_ACCESS_TOKEN,
    getCart,
    setAccessToken,
    clearAccessToken,
} from "../../actions"
import {getGlobalContent, getIsAuthenticated} from "../../selectors"
import {canUseDom} from '../../utils/dom'
import Cookies from 'universal-cookie';


function clearAccessTokenFunction(action) {
    try
    {
        const cookies = new Cookies();
        cookies.remove('eve_access');
    } catch (e) {
        console.error(e);
    }
}

export function* clearAccessTokenSaga() {
    yield takeLatest(CLEAR_ACCESS_TOKEN, clearAccessTokenFunction);
}

function* checkToken(action) {
    // Do not check the token on the server side, we will get this one the page is loaded
    if(!canUseDom) return;
    const global = yield select(getGlobalContent);
    if(!global) return;

    const isAuthenticated = yield select(getIsAuthenticated)
    if(!isAuthenticated)
    {
        yield put(clearAccessToken());
        return;
    }

    const cookies = new Cookies();
    const accessToken = cookies.get('eve_access')

    if(accessToken)
    {
        yield put(setAccessToken(accessToken));
        yield put(getCart());
    }
    else
    {
        //We can always add to wishlist
        yield put(clearAccessToken());
    }
}

function* checkTokenSaga() {
    yield takeLatest(CHECK_ACCESS_TOKEN, checkToken);
}

function* tokenSaga() {
    yield all([
        fork(checkTokenSaga),
        fork(clearAccessTokenSaga),
    ])
}

export default tokenSaga;


// WEBPACK FOOTER //
// ./src/sagas/account/token.js